import gql from "graphql-tag";

/**
 * Logs a part order a technician placed themselves.
 *
 * Always send `items: []` — the backend reconciles job service lines against the
 * items array, and omitting the key entirely used to throw before the guard added in
 * NUB-359. An empty array is the correct "this order has no line items yet" signal;
 * ops fills them in when reconciling.
 */
export const CREATE_PART_ORDER = gql`
  mutation createPartOrder($createPartOrderInput: CreatePartOrderInput!) {
    createPartOrder(createPartOrderInput: $createPartOrderInput) {
      id
      orderNumber
      status
      createdBy
      store {
        id
        name
      }
    }
  }
`;
